import { Creature } from "../classes/Creature.js";
import { tickCreature } from "../fightLoop.js";
import { emit, GameEvents } from "../events/eventBus.js";
import { useGameStore } from "../../stores/gameStore.js";

function createDummy(health, armor = 0) {
  const dummyWeapon = {
    attackSpeed: 999999,
    damage: 0,
    reloadSpeed: 0,
    magazineSize: 0,
    statusEffect: null,
  };
  return new Creature("Dummy", health, dummyWeapon, armor);
}

export function calculateDps(weapon, targetArmor = 0) {
  const game = useGameStore();
  game.isSimulating = true;

  const dummyHealth = 10000000;
  const maxTicks = 60 * 600;

  const attacker = new Creature("Attacker", Infinity, weapon, 0);
  const defender = createDummy(dummyHealth, targetArmor);

  let ticks = 0;
  while (defender.health > 0 && ticks < maxTicks) {
    tickCreature(attacker, () => {
      emit(GameEvents.CREATURE_ATTACK, { attacker, defender });
    });
    emit(GameEvents.STATUS_EFFECT_TICK, { target: defender });
    ticks++;
  }

  const seconds = ticks / 60;
  const damageDealt = dummyHealth - defender.health;
  const dps = damageDealt / seconds;

  game.isSimulating = false;
  return Math.round(dps * 100) / 100;
}
